export default "__VITE_ASSET__JU2dmfBO__"